import { TextInputValidationFn } from '@Shared/Components/Inputs/TextInput/TextInput'

export const AddressValidationV2: (storeID, t) => TextInputValidationFn = (storeID, t) => (value) => {
  if (![3, 8, 10, 21, 22, 42, 44].includes(+storeID)) {
    const regEx = /^(?=.*[a-åA-ÅΆ-ωΑ-ώА-Яа-яЀ-Џѐ-џѠ-ӹ])(?=.*[0-9])/
    if (regEx.test(`${value}`)) {
      return { success: true, errorMessage: '' }
    }
  } else {
    return { success: true, errorMessage: '' }
  }
  return {
    errorMessage: t('checkout:COF_REMEMBER_BOTH_STREET_AND_NUMBER'),
    success: false,
  }
}
